import React, { useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

export const PrivacyPolicy = () => {
   useEffect(() => {
       window.scrollTo(0, 0);
     }, []);

  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col md={10} lg={8}>
          <Card className="shadow-lg border-0 rounded-4 p-4">
            <Card.Body>
              <h2 className="text-center mb-4 text-danger fw-bold">
                Privacy Policy
              </h2>
              <section className="mb-4">
                <h5 className="fw-bold">1. Information We Collect</h5>
                <ul>
                  <li>Personal Details: Name, Mobile number, Email, Address</li>
                  <li>
                    Order & Transaction: Product details, order history, payment
                    mode
                  </li>
                  <li>
                    Technical Info: IP, browser, device, cookies, activity logs
                  </li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 className="fw-bold">2. How We Use Your Information</h5>
                <ul>
                  <li>To process & fulfill orders</li>
                  <li>To send updates & notifications</li>
                  <li>To provide customer support</li>
                  <li>To improve services & website</li>
                  <li>For promotions (only if opted in)</li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 className="fw-bold">3. Data Protection and Security</h5>
                <p>
                  We secure your data with industry standards, encrypted
                  transactions, and restricted staff access.
                </p>
              </section>

              <section className="mb-4">
                <h5 className="fw-bold">4. Cookies & Tracking</h5>
                <p>
                  Cookies help us improve browsing experience. You can disable
                  them anytime in browser settings.
                </p>
              </section>

              <section className="mb-4">
                <h5 className="fw-bold">5. Sharing of Information</h5>
                <p>
                  We don’t sell/rent your data. Shared only with courier,
                  payment gateways, or legal authorities.
                </p>
              </section>

              <section className="mb-4">
                <h5 className="fw-bold">6. Your Rights</h5>
                <p>
                  You can request to view, update, or delete your data and
                  opt-out of marketing at any time.
                </p>
              </section>

              <section className="mb-4">
                <h5 className="fw-bold">7. Children’s Privacy</h5>
                <p>
                  Our website is not for children under 13. We don’t knowingly
                  collect data from minors.
                </p>
              </section>

              <section className="mb-4">
                <h5 className="fw-bold">8. Links to Other Websites</h5>
                <p>
                  External websites may have their own privacy policies. We are
                  not responsible for them.
                </p>
              </section>

              <section className="mb-4">
                <h5 className="fw-bold">9. Changes to This Policy</h5>
                <p>
                  We may update this policy. Please review this page regularly
                  to stay informed.
                </p>
              </section>

              <section>
                <h5 className="fw-bold">10. Contact Us</h5>
                <p>
                  📍 Sri Mangalambika Stores <br />
                  📧 Email: srimangalambikastore.com <br />
                  📱 Phone/WhatsApp: 6383786782, 9363700957
                </p>
              </section>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
